import { AdaraSignet } from "./AdaraSignet";

export function SidebarBrand() {
  return (
    <div className="flex items-center gap-2.5 text-white">
      <AdaraSignet className="h-7 w-7" />
      <span className="text-[15px] font-semibold">Adara</span>
      <span className="text-xs text-adara-300">Panel Agenta</span>
    </div>
  );
}
